import { render } from "./Index.vue?vue&type=template&id=2b8d2eac&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=2b8d2eac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2b8d2eac"

export default script